import { render, staticRenderFns } from "./SOHeader.vue?vue&type=template&id=ddc8afa0&scoped=true&"
import script from "./SOHeader.vue?vue&type=script&lang=ts&"
export * from "./SOHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SOHeader.vue?vue&type=style&index=0&id=ddc8afa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8afa0",
  null
  
)

export default component.exports